import { UCAPI_PROD_DOMAIN } from "environments/environment-domain";
import {
  AngularEnvironment,
  isTestToolEnabledByDomain,
} from "environments/environment-type";
import { NgxLoggerLevel } from "ngx-logger";

export const environment: AngularEnvironment = {
  production: true,

  DOMAIN: UCAPI_PROD_DOMAIN,
  API_URL: `https://${UCAPI_PROD_DOMAIN}/api/v2`,

  logger: {
    level: NgxLoggerLevel.INFO,
    enableSourceMaps: true, // Required to display meaningful file names in console.
    // serverLoggingUrl: '/api/logs',
    // serverLogLevel: NgxLoggerLevel.ERROR
  },

  testToolEnable: isTestToolEnabledByDomain(),

  keycloakConfig: {
    url: "https://sso.cloud-cfg.com",
    realm: "login",
  },
};
